/**
 * Branded identifier types. Each id is a nominal subtype of string|number
 * so accidental swaps (passing a CardId where a PlayerId is expected) are
 * type errors. Construction goes through the smart constructors at the
 * system boundary (DB reads, HTTP payloads); internal code passes the
 * branded value through without re-validating.
 */
import { Schema as S } from 'effect';
export const GameId = S.String.pipe(S.brand('GameId'));
export const CardId = S.String.pipe(S.brand('CardId'));
export const PlayerId = S.String.pipe(S.brand('PlayerId'));
export const MatchUlid = S.String.pipe(S.brand('MatchUlid'));
export const EventSeq = S.Number.pipe(S.int(), S.nonNegative(), S.brand('EventSeq'));
export const ZoneId = S.String.pipe(S.brand('ZoneId'));
export const ResourceKind = S.String.pipe(S.brand('ResourceKind'));
/**
 * Trust-the-string constructors for use INSIDE a single trusted boundary —
 * e.g., when a freshly-generated ULID has just been minted in the same
 * function and re-parsing it through the schema would be ceremony. Outside
 * a trusted boundary, decode through the schema.
 */
export const unsafeGameId = (s) => s;
export const unsafeCardId = (s) => s;
export const unsafePlayerId = (s) => s;
export const unsafeMatchUlid = (s) => s;
export const unsafeEventSeq = (n) => n;
export const unsafeZoneId = (s) => s;
export const unsafeResourceKind = (s) => s;
//# sourceMappingURL=ids.js.map